import { useEffect, useState } from 'react';
import { ICoinNewsAI, ITokenNewsItem } from '@kattana-io/common';
import ShortNews from '../../molecules/ShortNews';
import Loader from '../common/Loader';
import Text from '../../atoms/Text';
import { KattanaAPI } from '../../store/createStore';

interface ICoinNewsProps {
  slug: string;
  data?: ITokenNewsItem[];
  AI?: ICoinNewsAI;
}

/**
 * Temporary solution to fetch news according to the mapping
 */
const useCoinNews = (
  slug: string,
  data?: ITokenNewsItem[],
  AI?: ICoinNewsAI
) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [news, setNews] = useState<ITokenNewsItem[]>([]);
  const [ai, setAI] = useState<ICoinNewsAI>();

  useEffect(() => {
    const controller = new AbortController();
    if (slug && !data) {
      setLoading(true);
      KattanaAPI.coinNews(slug, controller)
        .then((data) => {
          if (data) {
            setNews(data.news);
            setAI(data.ai);
          } else {
            setNews([]);
            setAI(undefined);
          }
          setLoading(false);
        })
        .catch(() => {
          if (!controller.signal.aborted) {
            setNews([]);
            setAI(undefined);
            setLoading(false);
          }
        });
    } else {
      if (!controller.signal.aborted) {
        setNews(data || []);
        setAI(AI || undefined);
        setLoading(false);
      }
    }

    return () => {
      controller.abort();
    };
  }, [slug, data]);

  return {
    loading,
    news,
    ai,
  };
};

const CoinNews = ({ slug, data, AI }: ICoinNewsProps) => {
  const { news, ai, loading } = useCoinNews(slug, data, AI);
  if (!slug) {
    return (
      <div className='miniNews'>
        <Text size={14} className='text--grey-400 text--nowrap'>
          Not available
        </Text>
      </div>
    );
  }
  if (loading) {
    return (
      <div className='centrify'>
        <Loader />
      </div>
    );
  }
  return <ShortNews news={news} ai={ai} />;
};

export default CoinNews;
